import React from "react";

const BudgetLineTable = ({ budgetLines }) => (
    <section className="card">
        <div className="table-header">
            <h3>Budget Lines</h3>
            {/* <button onClick={() => handleExport("budgetLines")}>Export Table</button> */}
        </div>
        <div className="table-container">
            <table>
                <thead>
                    <tr>
                        <th>Programme</th>
                        <th>Admin Unit</th>
                        <th>Fund</th>
                        <th>Budget</th>
                        <th>Spent</th>
                    </tr>
                </thead>
                <tbody>
                    {budgetLines.map((row, i) => (
                        <tr key={i}>
                            <td>{row.programme}</td>
                            <td>{row.adminUnit}</td>
                            <td>{row.fund}</td>
                            <td>{row.budget}</td>
                            <td>{row.spent}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </section>
);

export default BudgetLineTable;